export default "__VITE_ASSET__d5a4055f__"